module.exports = __webpack_public_path__ + "img/Rebar Detailing.6c5d9a03.png";